import { useEffect, useState } from 'react'
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

import { useTranslation } from "react-i18next";

import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage'

import { PagedListRequest } from 'domain/types/global/pagedListRequest';
import { USUARIOS_EMPRESA_GET } from 'domain/types/usuario/usuario';

import * as S from '../../pagedStyle';
import Avatar from 'base/src/components/Avatar';
import { FilterObject } from 'base/src/components/Filter';
import { GetPerfilAtivos } from 'base/src/store/perfil/action/perfilAction';
import { IOptionsIten } from 'base/src/components/Options';
import { PagedElement } from 'base/src/components/Paged/index'
import { useTheme } from 'base/src/utils/context/themeContext';
import { RootStateCarteira } from '../../../../store/carteiraReducer';
import { GetUsuariosCarteira, ResetUsuariosCarteiraPaged, AtualizarPermissaoCarteira } from '../../../../store/carteiraAdmin/actions/carteiraAdminAction';
import { UsuarioCarteiraResponse } from '../../../../types/carteiraAdmin/carteiraUsuarioResponse';
import { Switch, SwitchThumb } from 'base/src/components/Switch';
import { Icon } from '@iconify/react';
import { Label } from 'base/src/view/states/reduxView/styles';
import { View } from 'base/src/components/Basic/View/view';
import { Row } from 'base/src/components/Basic/Row/row';
import { CarteiraPermissaoTipo } from 'domain/types/_carteira/carteiraAdmin/carteiraPermissaoTipo';
const connector = connectUtil(
  (state: RootStateCarteira) => ({
    carteiraUsuarios: state.CarteiraAdminReducer.CarteiraUsuarios,
    homeInfo: state.CarteiraBaseReducer.CarteiraUsuario,
    sistemaID: state.UtilReducer.SistemaID,
    perfils: state.PerfilReducer.Perfils,
  }),
  { GetUsuariosCarteira, GetPerfilAtivos, ResetUsuariosCarteiraPaged, AtualizarPermissaoCarteira }
);

export interface CriarNotificacaoProps extends PropsFromRedux<typeof connector> {
  take: number;
}

function PagedUsuario(props: CriarNotificacaoProps) {
  const { theme } = useTheme();
  const _userData = _UserData;
  const { t } = useTranslation();
  const [request, setRequest] = useState<PagedListRequest<UsuarioCarteiraResponse>>({} as PagedListRequest<UsuarioCarteiraResponse>)

  useEffect(() => {
    props.ResetUsuariosCarteiraPaged(request, props.take)
  }, [])


  useEffect(() => {
    props.sistemaID && props.sistemaID != 0 && props.GetPerfilAtivos(props.sistemaID)
  }, [props.sistemaID])


  const fil: FilterObject[] = [{
    name: "Perfil de acesso",
    optionsGroup: [
      {
        nomeGrupo: t("Perfil"),
        options: props.perfils ? Array.from(props.perfils, (p) => ({ id: p.PerfilID.toString(), nome: p.Descricao } as IOptionsIten)).sort((a, b) => a.nome.localeCompare(b.nome)) : undefined,
      }
    ],
    label: "Selecione o perfil",
    multiple: true
  }

  ]


  function checkBoxChildren(u: UsuarioCarteiraResponse) {
    // Verifica se o usuário tem permissão específica baseada no CarteiraPermissaoTipoID
    let hasGerentePermission = u.PossuiPermissao && u.CarteiraPermissaoTipoID === CarteiraPermissaoTipo.Owner;
    let hasVisualizarPermission = hasGerentePermission || (u.PossuiPermissao && u.CarteiraPermissaoTipoID === CarteiraPermissaoTipo.SubOwner);


    function handlePermissionChange(checked: boolean, carteiraPermissaoTipoID: number) {
      // Implemente a lógica de atualização de permissão conforme necessário
      props.AtualizarPermissaoCarteira(props.homeInfo[0].CarteiraID, u.UsuarioID, carteiraPermissaoTipoID, checked, t);
    }

    function handleVisualizarPermissionChange(checked: boolean) {
      hasVisualizarPermission = checked;
      if(hasVisualizarPermission == false ) {
        hasGerentePermission = false
      }

      handlePermissionChange(checked, CarteiraPermissaoTipo.SubOwner)
    }

    function handleGerentePermissionChange(checked: boolean) {
      hasGerentePermission = checked
      if(hasGerentePermission == false && hasVisualizarPermission == true) {
        handlePermissionChange(true, CarteiraPermissaoTipo.SubOwner)
      }else{
        handlePermissionChange(checked, CarteiraPermissaoTipo.Owner)
      }
    }

    return (
      <S.UserContainer>
        <S.UserAvatar>
          <Avatar alt='avatar' borderColor={u.PossuiPermissao ? theme.colors.primary : theme.colors.negative} size='md' fallBack='as' src={u.ImagemUrl} />
        </S.UserAvatar>
        <S.UserInfo>
          <S.UserName>{u.NomeCompleto}</S.UserName>
          <S.UserFilial>{u.Email}</S.UserFilial>
        </S.UserInfo>
        <View style={{ 
          display: "flex",
          flex: "2 1 0%",
          flexFlow: "row-reverse",
          placeContent: "center flex-start",
          alignItems: "center",
          gap: "30px",
          flexDirection: "row",
          justifyContent: "flex-end"
        }}>
          <Row >
            <Label style={{height:"100%", marginBottom:"unset", marginRight:"10px"}}>Visualizar</Label>
            <Switch
              onCheckedChange={handleVisualizarPermissionChange}
              checked={hasVisualizarPermission}
              style={{minWidth:"40px"}}
            >
              <SwitchThumb>
                <Icon
                  icon={hasVisualizarPermission ? "mdi:check" : "mdi:close"}
                  height="1rem"
                  color={hasVisualizarPermission ? theme.colors.positive : theme.colors.negative}
                />
              </SwitchThumb>
            </Switch>
          </Row>
          <Row style={{ marginLeft: "100px" }}>
            <Label style={{height:"100%", marginBottom:"unset", marginRight:"10px"}}>Gerente</Label>
            <Switch
              onCheckedChange={handleGerentePermissionChange}
              checked={hasGerentePermission}
              style={{minWidth:"40px"}}
            >
              <SwitchThumb>
                <Icon
                  icon={hasGerentePermission ? "mdi:check" : "mdi:close"}
                  height="1rem"
                  color={hasGerentePermission ? theme.colors.positive : theme.colors.negative}
                />
              </SwitchThumb>
            </Switch>
          </Row>
        </View>
      </S.UserContainer>
    );
  }

  function handlePagination(request: PagedListRequest<UsuarioCarteiraResponse>) {
    props.GetUsuariosCarteira(props.homeInfo[0].CarteiraID, _userData.Get(UserDataBaseEnum.EmpresaID), request, t)
  }

  return (
    <>
      <PagedElement
        take={props.take}
        element={checkBoxChildren}
        handlePagination={handlePagination}
        originalState={props.carteiraUsuarios}
        loadingState={USUARIOS_EMPRESA_GET}
        filter={{
          filters: fil,
          title: "Filtro por usuário",
          description: "Selecione os filtros",
        }}

        searchType={['NomeCompleto']}
        searchBar={{
          title: "Buscar",
          placeHolder: "Nome do Usuário",
        }}

        paged={{
          pagedRequest: request,
          pagedSetRequest: setRequest
        }}
      />
    </>
  )
}

export default connector(PagedUsuario);